module.exports = __webpack_public_path__ + "img/title3.311abc2e.png";